// extracted by mini-css-extract-plugin
export default {"p_content":"_8b24419497"};